import { render, staticRenderFns } from "./ListaPreguntas.vue?vue&type=template&id=6f3af831&scoped=true"
import script from "./ListaPreguntas.vue?vue&type=script&lang=js"
export * from "./ListaPreguntas.vue?vue&type=script&lang=js"
import style0 from "./ListaPreguntas.vue?vue&type=style&index=0&id=6f3af831&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3af831",
  null
  
)

export default component.exports